'use strict';

var $ = require('../internals/export');

var getBuiltIn = require('../internals/get-built-in');

var aCallable = require('../internals/a-callable');

var anObject = require('../internals/an-object');

var speciesConstructor = require('../internals/species-constructor');

var iterate = require('../internals/iterate'); // `Set.prototype.union` method
// https://github.com/tc39/proposal-set-methods


$({
  target: 'Set',
  proto: true,
  real: true,
  forced: true
}, {
  union: function union(iterable) {
    var set = anObject(this);
    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))(set);
    iterate(iterable, aCallable(newSet.add), {
      that: newSet
    });
    return newSet;
  }
});